import React from 'react';
import PropTypes from 'prop-types';
import { InfoIcon } from 'ui-components/components/info-icon';
import { MDash } from 'ui-components/components/mdash';
import style from '../voided-external-fulfillment-details.module.less';

export const ExternalFulfillmentStatusAndIcon = ({ externalFulfillmentError, externalFulfillmentStatus }) => {
  if (!externalFulfillmentStatus) {
    return <MDash />;
  }

  return (
    <div className={style['status-value']}>
      <span>{externalFulfillmentStatus}</span>
      {externalFulfillmentError && (
        <InfoIcon className={style['status-icon']} color='white' size='small' tooltipText={externalFulfillmentError} />
      )}
    </div>
  );
};

ExternalFulfillmentStatusAndIcon.propTypes = {
  externalFulfillmentError: PropTypes.string,
  externalFulfillmentStatus: PropTypes.string,
};
